import * as styles from './styles.css';
import { BANNER_UTP } from './constants';
import { Button, Responsive, TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { NBSP } from 'shared/constants/symbols';
import { RefObject } from 'react';

interface IGiftBannerProps {
  containerRef: RefObject<HTMLDivElement>;
  device: TDeviceType;
  handleOpenModal: VoidFunction;
}

export const GiftBanner: React.FC<IGiftBannerProps> = ({ containerRef, device, handleOpenModal }) => {
  return (
    <div ref={containerRef} className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          Размещаетесь впервые?{' '}
          <div className={styles['colored']}>
            Дарим <span className={styles['rotated']}>1000 бонусов</span> новым{NBSP}хостам
          </div>
        </div>
        <div className={styles['list']}>
          {BANNER_UTP.map(({ id, title, notice }) => (
            <div className={styles['item']} key={id}>
              <div className={styles['number']}>{id}</div>
              <div className={styles['item-title']}>{title}</div>
              {notice && <div className={styles['item-notice']}>{notice}</div>}
              <Responsive desktop>
                {id === 1 && (
                  <div className={styles['btn']}>
                    <Button onClick={handleOpenModal} fullWidth size="L">
                      Войти
                    </Button>
                  </div>
                )}
              </Responsive>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
